import { DEFAULT_LOGO_URL } from "~/lib/constants/generalConstants";

const IK_BASE = "https://ik.imagekit.io/officehub";
const OG_TRANSFORM = "tr:w-1200,h-630,fo-auto,f-jpg";

export function resolveMetaOgImageUrl(imageUrl?: string): string {
    const url = imageUrl || DEFAULT_LOGO_URL;

    // Already an ImageKit URL: swap in OG transform instead of double-wrapping
    if (url.startsWith(IK_BASE)) {
        const rest = url.slice(IK_BASE.length).replace(/^\/tr:[^/]+/, "");
        return `${IK_BASE}/${OG_TRANSFORM}${rest}`;
    }

    // Absolute URL (S3, CloudFront): proxy through ImageKit
    if (url.startsWith("http")) {
        return `${IK_BASE}/${OG_TRANSFORM}/${url}`;
    }

    // Relative path within the ImageKit origin
    return `${IK_BASE}/${OG_TRANSFORM}/${url.replace(/^\//, "")}`;
}

export function getMetaOgTags({
    title,
    description,
    imageUrl = DEFAULT_LOGO_URL,
    canonicalUrl,
    imageWidth,
    imageHeight,
}: {
    title: string,
    description: string,
    imageUrl?: string,
    canonicalUrl: string,
    imageWidth?: number,
    imageHeight?: number,
}) {
    const resolvedImageUrl = resolveMetaOgImageUrl(imageUrl);

    return [
        ...(title ? [{ title }] : []),
        { name: "description", content: description },
        { property: "og:type", content: "website" },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:image", content: resolvedImageUrl },
        ...(imageWidth ? [{ property: "og:image:width", content: String(imageWidth) }] : []),
        ...(imageHeight ? [{ property: "og:image:height", content: String(imageHeight) }] : []),
        { property: "og:image:alt", content: title }, // optional
        { property: "og:url", content: canonicalUrl }, // <---- ADD THIS
        { property: "og:site_name", content: "Office Hub" },
        { property: "og:image:type", content: "image/jpeg" },

        // Twitter
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:site", content: "@officehubtweet" },
        { name: "twitter:title", content: title },
        { name: "twitter:url", content: canonicalUrl },

        { name: "twitter:description", content: description },
        { name: "twitter:creator", content: "@officehubtweet" },
        { name: "twitter:image", content: resolvedImageUrl },
        { name: "twitter:image:src", content: resolvedImageUrl },
    ];
}